import { Helmet } from 'react-helmet-async'

import defaultFavicon from './images/favicon-default.svg'
import errorFavicon from './images/favicon-error.svg'
import inProgressFavicon from './images/favicon-in-progress.svg'
import successFavicon from './images/favicon-success.svg'
import type { State } from '../../features/store'
import { useStore } from '../../features/store/index.ts'

const favicons: Record<State['favicon'], string> = {
  default: defaultFavicon,
  error: errorFavicon,
  'in-progress': inProgressFavicon,
  success: successFavicon,
}

export function Favicon() {
  const favicon = useStore((state) => state.favicon ?? 'default')

  return (
    <Helmet>
      <link key="favicon" rel="icon" href={favicons[favicon]} />
    </Helmet>
  )
}
